import { useState } from 'react';

import { gql, useQuery } from '@apollo/client';

export const GET_DOCUMENT_IMPORTER_TEMPLATES = gql`
  query getDocumentImporterTemplates($companyId: String!, $queryOptions: QueryOptionsInput) {
    getDocumentImporterTemplates(companyId: $companyId, queryOptions: $queryOptions) {
      collection {
        _id
        title
        separator
        valueEmployeeId
        companyId
        createdAt
        createdBy
      }
      totalCount
    }
  }
`;

export const useGetDocumentImporterTemplates = (companyId?: string) => {
  const [currentPage, setPage] = useState(1);
  const [currentNameSort, setNameSort] = useState<{ field: string; sortBy: number }[]>([
    { field: 'title', sortBy: 1 },
  ]);
  const pageSize = 12;
  const { data, loading } = useQuery(GET_DOCUMENT_IMPORTER_TEMPLATES, {
    variables: {
      companyId,
      queryOptions: {
        limit: pageSize,
        skip: pageSize * currentPage - pageSize,
        sort: currentNameSort,
      },
    },
    skip: !companyId,
    fetchPolicy: 'no-cache',
  });

  const documentImporterTemplates = data?.getDocumentImporterTemplates || {};

  return {
    collection: documentImporterTemplates?.collection || [],
    loading,
    paginationConfig: {
      total: documentImporterTemplates?.totalCount || 0,
      pageSize,
      current: currentPage,
      onChange: (page: number) => setPage(page),
    },
    onTableChange: (a: any, b: any, { order }: any) => {
      if (order) {
        const sortBy = order === 'ascend' ? 1 : -1;

        setNameSort([{ field: 'title', sortBy }]);
      }
    },
  };
};
